import React from "react"
import renderPaddingOrFullBleed from "../renderPaddingOrFullBleed"
import { HTMLEmbed } from "terra-one"

const FormatAndRenderHTMLEmbed = ({ data, paddingClass, index, location, scriptMode }  ) => {
  const header = data?.header
  const subheader = data?.subHeader
  const HTML = data?.html?.blob?.childMarkdownRemark?.html
  const ratio = data?.componentAspectRatio
  const content = {
    header,
    subheader,
    HTML,
    ratio,
  }
  if (scriptMode && scriptMode === true) {
    return (
      <div className="html-embed--script-mode">
        <HTMLEmbed
          content={content}
          key={index}
          contentfulId={data?.contentfulId}
        />
      </div>
    )
  }
  return (
    <>
      {renderPaddingOrFullBleed(
        <HTMLEmbed
          content={content}
          key={index}
          contentfulId={data?.contentfulId}
        />
      )}
    </>
  )
}

export default FormatAndRenderHTMLEmbed
